import { render } from "./3DModel.vue?vue&type=template&id=236773dc&scoped=true"
import script from "./3DModel.vue?vue&type=script&lang=js"
export * from "./3DModel.vue?vue&type=script&lang=js"

import "./3DModel.vue?vue&type=style&index=0&id=236773dc&scoped=true&lang=css"

import exportComponent from "/Users/martinflores/Documents/kitsuu-landing/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-236773dc"]])

export default __exports__